/**
 * ケース商品の注文
 */
import { onReady, queryAll } from '@/utils/dom'
import { fadeIn, fadeOut, hide } from '@/utils/fade'
import { addCart, getFormCartItem } from '@/utils/cart'

const OVERLAY_ID = 'j-modal_ovrly'
const ESCAPE_KEY = 'Escape'
const OPTION_NOT_REPEAT = 'OPT_NOT_REPEAT'
const OPTION_SHIPPING = 'OPT_CASE_SHIPPING_BASE'

//送料が必要な商品 ID
const SHIPPING_ITEM_IDS = [
    'ITM_CASE_CRAFT_200',
    'ITM_CASE_CRAFT_FLAT_10',
    'ITM_CASE_CRAFT_FLAT_20',
    'ITM_CASE_CRAFT_FLAT_30',
    'ITM_CASE_CRAFT_FLAT_40',
    'ITM_CASE_CRAFT_FLAT_50',
    'ITM_CASE_CRAFT_ORI_FLAT_10',
    'ITM_CASE_CRAFT_ORI_FLAT_20',
    'ITM_CASE_CRAFT_ORI_FLAT_30',
    'ITM_CASE_CRAFT_ORI_FLAT_40',
    'ITM_CASE_CRAFT_ORI_FLAT_50',
    'ITM_CASE_CRAFT_ORI_FLAT_100',
    'ITM_CASE_CROSS_PACK',
    'ITM_CASE_PAPER_BOX',
]

/**
 * マウスオーバーによるサンプル画像の切り替え
 */
const initImageToggle = (): void => {
    queryAll('.j-tgl_img_thum').forEach((thumb) => {
        thumb.addEventListener('mouseenter', () => {
            const toggleImg = thumb.closest('.order-item_image')?.querySelector<HTMLImageElement>('.j-tgl_img')
            const thumbSrc = thumb.querySelector(':scope > img')?.getAttribute('src')
            if(toggleImg && thumbSrc) {
              //初期化（img を隠す）後、サムネイルの画像に書換えて表示
                hide(toggleImg)
                toggleImg.setAttribute('src', thumbSrc)
                fadeIn(toggleImg)
            }
          //サムネイルの外枠を初期化
            thumb.closest('.item-img_thum')
                ?.querySelectorAll('.j-tgl_img_thum')
                .forEach((elm) => elm.classList.remove('is-select'))
        })
    })
}

/**
 * 各モーダルウィンドウ制御系
 */
const initModals = (): void => {
    let modalState = false
    const overlay = document.getElementById(OVERLAY_ID)

    const closeModal = (): void => {
        if(!modalState) return
        queryAll(`.j-modal_item, #${OVERLAY_ID}`).forEach((elm) => fadeOut(elm))
        modalState = false
    }

  //サムネイル画像拡大表示
    queryAll('.j-modal_tgl-image').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault()
            const modal = document.getElementById('item-modal-image')
            const img = trigger.querySelector('img')
            const caption = img?.getAttribute('alt') ?? ''
          //モーダル内の要素を調整
            const title = modal?.querySelector('#item-modal-image-title')
            if(title) title.textContent = caption
            const modalImg = modal?.querySelector('img')
            if(modalImg && img) {
                modalImg.setAttribute('src', img.getAttribute('src') ?? '')
                modalImg.setAttribute('alt', caption)
            }
          //表示
            modalState = true
            if(modal) fadeIn(modal, 'flex')
            if(overlay) fadeIn(overlay, 'flex')
        })
    })

  //非表示処理（クリック・Esc キー）
    queryAll(`.j-modal_close, #${OVERLAY_ID}`).forEach((closer) => {
        closer.addEventListener('click', closeModal)
    })
    window.addEventListener('keyup', (event) => {
        if(event.key===ESCAPE_KEY) closeModal()
    })
}

/**
 * カートへ入れる処理
 *   「j-send-form」が付いた要素のクリックでカートへ追加
 *   物販商品のためリピート注文不可、送料が必要な商品は送料のオプションを追加
 */
const initAddCart = (): void => {
    document.addEventListener('click', (event) => {
        if(!(event.target instanceof Element) || !event.target.closest('.j-send-form')) return
        const item = getFormCartItem([OPTION_NOT_REPEAT])
        if(SHIPPING_ITEM_IDS.includes(item.item_id)) {
            item.item_option_id_set.push({ item_option_id_list: [OPTION_SHIPPING] })
        }
        addCart([item])
    })
}

onReady(() => {
    initImageToggle()
    initModals()
    initAddCart()
})
